import { useTranslations } from 'next-intl';

type FileUploadSampleFilesProps = {
  textWithBrackets?: boolean;
  className?: string;
};

const EXTENSION_FILES = ['csv', 'xlsx'];

const FileUploadSampleFiles = ({
  textWithBrackets = true,
  className
}: FileUploadSampleFilesProps) => {
  const t = useTranslations();
  const sampleButton = EXTENSION_FILES.map((extension, index) => (
    <p className="me-1 m-0" key={extension}>
      {`.${extension} `}
      <a
        className={className ?? 'text-capitalize'}
        download={`sample_parts.${extension}`}
        rel="noopener noreferrer"
        target="_blank"
        href={`/wcs-static/sample_parts.${extension}`}
      >
        {textWithBrackets ? `(${t('SAMPLE')})` : t('SAMPLE')}
      </a>
      {index < EXTENSION_FILES.length - 1 ? ',' : '.'}
    </p>
  ));
  return (
    <div slot="field-note">
      <div className="text-xs d-flex flex-wrap u-color--ExtraDarkGray">
        <span className="me-1">{`${t('SUPPORTED_FILE_TYPES')}:`}</span>
        {sampleButton}
      </div>
    </div>
  );
};

export default FileUploadSampleFiles;
